<template>

    <div class="popup active">
        <div class="notice_popup human int">
            <div class="close">
                <img src="/images/close.png" alt="닫기" @click="$emit('close', true)"/>
            </div>
			<div class="tit">회원 탈퇴가 완료되었습니다.</div>		
            <div class="select-btn">
                <div class="btn blue" @click="$emit('close', true)">확인</div>
            </div>
        </div>
    </div>

</template>

<script>

export default {

	components : {		
	},

	props: ['param'],

	data() {
		return {
		};
	},
	beforeCreate() {
		// console.log('beforeCreate');
	},
	created() {
		// console.log('created');
	},
	beforeMount() {
		// console.log('beforeMount');		
	},
	mounted() {
		// console.log('mounted');
	},
	beforeUpdate() {
		// console.log('beforeUpdate');
	},
	updated() {
		// console.log('update');
	},
	beforeDestroy() {
		// console.log('beforeDestroy');
	},
	destroyed() {
		// console.log('destroyed');
	},

	methods: {
		
	},
};
</script>
